// Generated by scripts/build-ui-icons.mjs.
export { Medal as default } from "../ui/glyphs-5";
